// cleanup_convert_to_typescript_file_LOGIN_WORKFLOW
// cleanup_class_to_function_LOGIN_WORKFLOW

import React, { Component } from 'react';

import { withStyles } from '@glu/theming';

import { getLocale } from 'utils/browserLocale';
import { nukeEntireSession } from 'api/user/service';
import { JSSClasses } from 'proptypes/jss-prop-types';
import { fetchLoginResource } from 'api/locale/service';
import { getLoginBulletinMessages, getMessage } from 'api/notifications/service';
import DangerousContent from 'components/dangerousContent/DangerousContent';
import defaultLocale from 'components/locale/defaultLocale';

import Footer from './Footer';
import LeftPanel from './LeftPanel';
import RightPanel from './RightPanel';
import styles from './Login.styles';

/*
 * @TODO CB-20315
 * Login
 */
export class LoginComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
      footerContent: '',
      locale: null,
      sessionValue: sessionStorage.getItem('redirecttoken')
    };
  }

  componentDidMount() {
    nukeEntireSession();
    const login = fetchLoginResource(getLocale())
      .then(({ localeData: locale }) => {
        this.setState({ locale: { ...defaultLocale, ...locale } });
      })
      .catch(() => {
        this.setState({ locale: defaultLocale });
      });
    const content = getLoginBulletinMessages({})
      .then(({ success, data = {} }) => {
        if (success) {
          this.setState({ content: data.message });
        }
      })
      // eslint-disable-next-line no-console
      .catch(console.error);
    const footer = getMessage({ service: 'login_footer' })
      .toPromise()
      .then(({ data = {} }) => {
        if (data && data.message) {
          this.setState({ footerContent: data.message });
        }
      });
    // Returning promises to handle tests
    return Promise.all([login, content, footer]);
  }

  render() {
    const { content, footerContent, locale, sessionValue } = this.state;
    const {
      classes: { background, container, login }
    } = this.props;

    return (
      <div className={background}>
        <div className={container}>
          <div className={login}>
            {locale && <LeftPanel locale={locale} sessionValue={sessionValue} />}
            {locale && (
              <RightPanel locale={locale} content={<DangerousContent content={content} />} />
            )}
          </div>
          <Footer
            content={<DangerousContent content={footerContent} />}
            sessionValue={sessionValue}
          />
        </div>
      </div>
    );
  }
}

LoginComponent.propTypes = {
  classes: JSSClasses
};

LoginComponent.defaultProps = {
  classes: {}
};

export default withStyles(styles)(LoginComponent);
